import AddIcon from "@mui/icons-material/Add";
import Box from "@mui/material/Box";
import Fab from "@mui/material/Fab";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import Grid from "@mui/material/Unstable_Grid2";
import { useDispatch, useSelector } from "react-redux";
import { Virtuoso } from "react-virtuoso";
import { v4 } from "uuid";
import { selectCanEditSuppliers } from "../redux/auth";
import {
  edit as editSupplier,
  selectors as supplierSelectors,
  selectEditSupplierAuthorizer,
} from "../redux/suppliers";
import SupplierRow from "./SupplierRow";

const Suppliers = (props) => {
  const dispatch = useDispatch();

  const canEditSuppliers = useSelector(selectCanEditSuppliers);
  const editSupplierAuthorizer = useSelector(selectEditSupplierAuthorizer);

  const onAddNewClick = () => {
    dispatch(editSupplier({ id: v4(), isNew: true }));
  };

  const suppliers = useSelector(supplierSelectors.selectAll);

  return (
    <Box className={props.className}>
      <Paper elevation={1}>
        <Grid container xs={12} spacing={0} className="header">
          <Grid xs={1} sm={0.5}></Grid>
          <Grid xs={11} sm={5.5} md={6.5}>
            Name
          </Grid>
          <Grid display={{ xs: "none", sm: "block" }} sm={3} md={2.5}>
            Saved At
          </Grid>
          <Grid display={{ xs: "none", sm: "block" }} sm={3} md={2.5}>
            Saved By
          </Grid>
        </Grid>
      </Paper>
      <Virtuoso
        data={suppliers}
        itemContent={(index, supplier) => (
          <SupplierRow
            canEdit={editSupplierAuthorizer(supplier)}
            key={supplier.id}
            supplier={supplier}
          />
        )}
        increaseViewportBy={200}
        style={{ height: "calc(100vh - 104px)" }}
      />
      {canEditSuppliers && (
        <Fab className="AddNewButton" onClick={onAddNewClick}>
          <AddIcon />
        </Fab>
      )}
    </Box>
  );
};

export default styled(Suppliers)(
  ({ theme }) => `
  .header {
    font-family: notosans-regular;
    font-weight: 400;
    padding: 12px 40px 12px 16px;
    background-color: ${theme.palette.header.main};
  }

  .MuiGrid2-root {
    overflow-x: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .AddNewButton {
    position: absolute;
    bottom: 16px;
    right: 16px;
  }
`,
);
